import React from 'react';

const WHATSAPP_NUMBER = '584242227314';
const MESSAGE = 'Hola, quiero información sobre seguros';

export const WhatsAppButton = ({ onClick }) => (
  <a
    href={`https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(MESSAGE)}`}
    target="_blank"
    rel="noopener noreferrer"
    onClick={onClick}
    data-testid="whatsapp-float-btn"
    aria-label="Escríbenos por WhatsApp"
    className="fixed bottom-6 right-6 z-50 group flex items-center gap-3 rounded-full bg-[#25D366] text-white shadow-2xl shadow-green-500/40 pl-4 pr-5 py-3 hover:bg-[#1ebe5d] hover:scale-105 transition-[transform,background-color] duration-300"
  >
    <span className="absolute inset-0 rounded-full bg-[#25D366] opacity-60 animate-ping -z-10 group-hover:hidden"></span>
    <svg viewBox="0 0 32 32" className="h-7 w-7 fill-current" aria-hidden="true">
      <path d="M16 3C9.4 3 4 8.3 4 14.9c0 2.3.7 4.5 1.9 6.4L4 29l7.9-2c1.3.5 2.7.7 4.1.7 6.6 0 12-5.3 12-11.9S22.6 3 16 3zm0 21.8c-1.3 0-2.6-.3-3.7-.8l-.3-.1-4.1 1.1 1.1-3.9-.2-.3c-1.1-1.6-1.7-3.5-1.7-5.4C7.1 9.6 11.1 5.7 16 5.7s8.9 3.9 8.9 8.7c0 4.8-4 8.7-8.9 8.7zm5-6.4c-.3-.1-1.6-.8-1.9-.9-.3-.1-.4-.1-.6.1-.2.3-.7.9-.9 1.1-.2.2-.3.2-.6.1-.3-.1-1.1-.4-2.2-1.3-.8-.7-1.4-1.6-1.5-1.9-.2-.3 0-.4.1-.6l.4-.5c.1-.2.2-.3.3-.5.1-.2 0-.4 0-.5-.1-.1-.6-1.4-.8-2-.2-.5-.4-.4-.6-.4h-.5c-.2 0-.5.1-.7.3-.2.3-.9.9-.9 2.2s1 2.5 1.1 2.7c.1.2 1.9 2.9 4.6 4 .6.3 1.1.4 1.5.6.6.2 1.2.2 1.7.1.5-.1 1.6-.6 1.8-1.3.2-.6.2-1.1.2-1.3-.1-.1-.3-.2-.5-.3z" />
    </svg>
    <span className="font-semibold text-sm hidden sm:inline">¿Hablamos?</span>
  </a>
);

export default WhatsAppButton;
